import {
  AkaAdvicePriceFormValues,
  AkaDeathAdviceFormValues,
  AkaDisabilityAdviceFormValues,
} from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";

import { AdviceProductDetailsFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { BackendProductInfo } from "Components/Features/CheckPrice/Products/productConstants";
import { AkaGroupLifePriceRequest } from "Store/akaAdvice/interfaces/AdviceProductPriceRequests";
import { AdvicePriceCalculationRequest } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { isDefined } from "Utils/functions";
import { format } from "date-fns";

export const mapToAkaGroupLifePriceReq = (
  formValues: AkaAdvicePriceFormValues,
  dateOfBirth: string,
  adviceDetailsFormValues: AdviceProductDetailsFormValues,
): {
  productPriceUrl: AdvicePriceCalculationRequest["productPriceUrl"];
  insuranceName: AdvicePriceCalculationRequest["insuranceName"];
  data: AkaGroupLifePriceRequest;
} => {
  const { akaGroupLifeDeathGLevel }: AkaDeathAdviceFormValues = formValues;
  const {
    incapacityOfWorkGLevel,
    timeLimitedDisabilityInterestGLevel,
  }: AkaDisabilityAdviceFormValues = formValues;
  return {
    productPriceUrl: BackendProductInfo.AKA_GROUP_LIFE.priceReqUrl,
    insuranceName: INSURANCE_NAME_VALUE.AKA_GROUP_LIFE,
    data: {
      member: {
        dateOfBirth,
        deathInsuranceCoverageGLevel: isDefined(akaGroupLifeDeathGLevel)
          ? Number(akaGroupLifeDeathGLevel)
          : null,
        incapacityOfWorkCoverageGLevel: isDefined(incapacityOfWorkGLevel)
          ? Number(incapacityOfWorkGLevel)
          : null,
        timeLimitedDisabilityInterestCoverageGLevel: isDefined(
          timeLimitedDisabilityInterestGLevel,
        )
          ? Number(timeLimitedDisabilityInterestGLevel)
          : null,
      },
      coInsured: mapCoInsured(formValues, adviceDetailsFormValues),
      showComposites: true,
    },
  };
};

const mapCoInsured = (
  formValues: AkaAdvicePriceFormValues,
  adviceDetailsFormValues: AdviceProductDetailsFormValues,
): AkaGroupLifePriceRequest["coInsured"] => {
  const { akaGroupLifeDeathCoInsuredGLevel }: AkaDeathAdviceFormValues =
    formValues;
  const {
    incapacityOfWorkCoInsuredGLevel,
    timeLimitedDisabilityInterestCoInsuredGLevel,
  }: AkaDisabilityAdviceFormValues = formValues;
  const { addCoInsured, coInsuredBirthDate } = adviceDetailsFormValues;
  if (
    addCoInsured !== BooleanFormType.TRUE ||
    !isDefined(coInsuredBirthDate) ||
    (!isDefined(akaGroupLifeDeathCoInsuredGLevel) &&
      !isDefined(incapacityOfWorkCoInsuredGLevel) &&
      !isDefined(timeLimitedDisabilityInterestCoInsuredGLevel))
  ) {
    return null;
  }
  return {
    dateOfBirth: format(coInsuredBirthDate, "yyyy-MM-dd"),
    deathInsuranceCoverageGLevel: isDefined(akaGroupLifeDeathCoInsuredGLevel)
      ? Number(akaGroupLifeDeathCoInsuredGLevel)
      : null,
    incapacityOfWorkCoverageGLevel: isDefined(incapacityOfWorkCoInsuredGLevel)
      ? Number(incapacityOfWorkCoInsuredGLevel)
      : null,
    timeLimitedDisabilityInterestCoverageGLevel: isDefined(
      timeLimitedDisabilityInterestCoInsuredGLevel,
    )
      ? Number(timeLimitedDisabilityInterestCoInsuredGLevel)
      : null,
  };
};
